import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../../services/auth/auth.service';
import { NavigationService } from '../../services/navigation/navigation.service';

@Injectable()
export class InitialStateAccessGuard {
  constructor(
    private authService: AuthService,
    private navigationService: NavigationService,
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (this.authService.getStatus().getValue() === '0') {
      this.navigationService.redirectToLayout();
      return;
    }

    return true;
  }
}
